module.exports = __webpack_public_path__ + "img/TEL-100.7ef959e1.png";